var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 12.5C10.9375 11.4226 11.3655 10.3892 12.1274 9.62738C12.8892 8.86551 13.9226 8.4375 15 8.4375C16.0774 8.4375 17.1108 8.86551 17.8726 9.62738C18.6345 10.3892 19.0625 11.4226 19.0625 12.5C19.0625 13.5774 18.6345 14.6108 17.8726 15.3726C17.1108 16.1345 16.0774 16.5625 15 16.5625C13.9226 16.5625 12.8892 16.1345 12.1274 15.3726C11.3655 14.6108 10.9375 13.5774 10.9375 12.5Z",
    fill: "#673C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.71749 11.0962C4.92485 8.58323 6.06954 6.24004 7.92433 4.53182C9.77913 2.8236 12.2084 1.87524 14.73 1.875H15.27C17.7916 1.87524 20.2208 2.8236 22.0756 4.53182C23.9304 6.24004 25.0751 8.58323 25.2825 11.0962C25.5141 13.9019 24.6479 16.6879 22.8662 18.8675L16.875 26.195C16.6479 26.4729 16.3619 26.6969 16.0376 26.8507C15.7133 27.0045 15.3589 27.0843 15 27.0843C14.6411 27.0843 14.2867 27.0045 13.9624 26.8507C13.6381 26.6969 13.3521 26.4729 13.125 26.195L7.13499 18.8675C5.35287 16.6881 4.48618 13.902 4.71749 11.0962ZM15 6.5625C13.4253 6.5625 11.915 7.18806 10.8015 8.30155C9.68804 9.41505 9.06249 10.9253 9.06249 12.5C9.06249 14.0747 9.68804 15.5849 10.8015 16.6984C11.915 17.8119 13.4253 18.4375 15 18.4375C16.5747 18.4375 18.0849 17.8119 19.1984 16.6984C20.3119 15.5849 20.9375 14.0747 20.9375 12.5C20.9375 10.9253 20.3119 9.41505 19.1984 8.30155C18.0849 7.18806 16.5747 6.5625 15 6.5625Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.dbd4d525bdb0588a48b75a8a1df2e2f5.svg";
export { ForwardRef as ReactComponent };